export default __webpack_public_path__ + "static/media/uniCampus3dgazebo-phoneSize.aff62ac2.gif";